import { InputHTMLAttributes, forwardRef } from 'react';
import cx from 'classnames';

export interface ToggleProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
  ({ checked = false, onChange, disabled, className, id, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.checked);
    };

    return (
      <label
        className={cx(
          'relative inline-flex items-center cursor-pointer',
          {
            'opacity-50 cursor-not-allowed': disabled,
          },
          className
        )}
      >
        <input
          ref={ref}
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          id={id}
          className="sr-only peer"
          {...props}
        />
        <div
          className={cx(
            'w-11 h-6 rounded-full peer transition-colors duration-200',
            'peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-500 peer-focus:ring-offset-2',
            'after:content-[""] after:absolute after:top-[2px] after:left-[2px]',
            'after:bg-white after:rounded-full after:h-5 after:w-5',
            'after:transition-transform after:duration-200',
            'peer-checked:after:translate-x-full peer-checked:after:border-white',
            {
              'bg-gray-200 dark:bg-gray-700': !checked,
              'bg-primary-600 dark:bg-primary-500': checked,
            }
          )}
        />
      </label>
    );
  }
);

Toggle.displayName = 'Toggle';
